import { LOCAL_STORAGE_AUTH_CHECK_KEY } from "~/_legacy/constants/auth";

export const getCookieValue = (key: string) => {
  const cookieArr = document.cookie.split(";");

  for (let i = 0; i < cookieArr.length; i++) {
    const cookiePair = cookieArr[i].split("=");
    const cookieName = cookiePair[0].trim();

    if (cookieName === key) {
      return decodeURIComponent(cookiePair[1]);
    }
  }

  return null;
};

export const removeCookieValue = (key: string) => {
  const cookie = [];
  cookie.push(key + "=");
  cookie.push("expires=" + new Date(Date.now() - 86400000).toUTCString());
  document.cookie = cookie.join("; ");
};

export const checkIsLoggedIn = () => {
  const authCheck = localStorage.getItem(LOCAL_STORAGE_AUTH_CHECK_KEY);
  return authCheck === "true";
};
